import { Box, Typography } from "@mui/material";
import { roles } from "../../types/authTypes";
import { COUNTRIES } from "../../constants/countries";
import ProfileImg from "../ProfileImg/ProfileImg";
import PremiumBadgeIcon from "../../img/icons/vip.png";
interface FlagProps {
  countryLabel: string | undefined;
}

export const Flag = ({ countryLabel }: FlagProps) => {
  const getCodeFromLabel = (
    countryLabel: string | undefined
  ): string | undefined => {
    if (countryLabel === undefined) {
      return undefined;
    }
    const normalizedLabel = countryLabel.toLowerCase(); // Convertimos a minúsculas para comparar sin importar mayúsculas

    const foundCountry = COUNTRIES.find(
      (country) => country.label.toLowerCase() === normalizedLabel
    );

    return foundCountry ? foundCountry.code : undefined;
  };

  let flag = <></>;
  const code = getCodeFromLabel(countryLabel);
  if (code) {
    flag = (
      <ProfileImg
        imgUrl={`https://flagcdn.com/w40/${code.toLowerCase()}.png`}
        size={16}
      />
    );
  }
  return flag;
};

interface UserNameProps {
  name: string;
  variant: any;
  justifyContent?: any;
  country?: string;
  role: roles | undefined;
}

const UserNameBasic = ({
  name,
  variant,
  justifyContent: justifyContentProps,
  role,
  country,
}: UserNameProps) => {
  return (
    <Box
      sx={{
        width: "fit-content",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: justifyContentProps
          ? justifyContentProps
          : "flex-start",
        columnGap: "0.5",
      }}
      aria-label="Username Title"
    >
      <Box sx={{ width: "100%" }}>
        <Typography variant={variant}>{name}</Typography>
      </Box>

      {role === roles.PREMIUM && (
        <Box sx={{ width: "25px", marginRight: "5px" }}>
          <ProfileImg imgUrl={PremiumBadgeIcon} size={20} />
        </Box>
      )}

      {country && (
        <Box sx={{ width: "25px" }}>
          <Flag countryLabel={country} />
        </Box>
      )}
    </Box>
  );
};

export default UserNameBasic;
